module.exports = __webpack_public_path__ + "img/cases-brand-vive-4.34713bcf.jpg";